export default __webpack_public_path__ + "static/media/slide4.09caad2d.png";